import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast';

// @ui-elements
import Header from './components/Layout/Header'

import PrivateRoutes from './components/Navigation/PrivateRoutes'
import Index from './pages/Index'
import Register from './pages/Register'
import Login from './pages/Login'
import Home from './pages/Home'
import Documents from './pages/Documents'
import Catalog from './pages/Catalog'
import Datasheets from './pages/Datasheets'
import { CatalogueProvider } from './components/context/CatalogueWrapper'
import PageNotFound from './pages/PageNotFound'
import ConfirmEmail from './pages/ConfirmEmail'
import PasswordReset from './pages/PasswordReset';
import VerificationCode from './pages/VerificationCode';

function App() {
  return (
    <>
      <Router>
        <div className="flex flex-col min-h-screen">
          <Header />
          <Routes>
            <Route path='app/' element={<Login />} />
            <Route path='app/login' index element={<Login />} />
            <Route path='app/register' element={<Register />} />
            <Route path='app/signup/*' element={<ConfirmEmail />}></Route>
            <Route path='app/password-reset' element={<PasswordReset />}></Route>
            <Route path='app/password-verification-token' element={<VerificationCode />}></Route>
            <Route path='app/*' element={<PageNotFound />} />
            <Route path='app/users/register/checktoken/:token' element={<ConfirmEmail />} />

            <Route element={<PrivateRoutes />}>
              <Route path='app/dashboard' element={<Home />} exact />
              <Route path='app/documents' element={<Documents />} exact />
              <Route path='app/datasheets' element={<Datasheets />} exact />
              <Route path='app/catalog' element={
                <CatalogueProvider>
                  <Catalog />
                </CatalogueProvider>
              }
                exact />
            </Route>

          </Routes>
        </div>
      </Router>
      <Toaster
        position="bottom-right"
        reverseOrder={true}
        toastOptions={{ duration: 4000 }}
      />
    </>
  );
}

export default App;
